import { Row, Col, Space } from "antd";
import { ReButton } from "@/components/refineElement";
import DraggableTable from "@@/src/components/draggableTable";
import { getLangList } from '@/lib/i18n';
import { hasPermission } from "@/lib/permissionUtil";
import { ClassType } from './types';

type Props = {
  classArray: ClassType[];
  clickClassEdit: Function;
  clickClassDelete: Function;
  updateClassSortFunction: Function;
  clickSubjectEdit: (classInfo: ClassType, e: any) => void;
}

function Classes(props: Props) {
  const { classArray, clickClassEdit, clickClassDelete, updateClassSortFunction, clickSubjectEdit } = props;
  const studentListT: any = getLangList("studentList");
  const subjectT: any = getLangList("subject");
  const buttonT: any = getLangList("button");

  const columns = [
    { title: studentListT.CLASS, dataIndex: "className" },
    { title: studentListT.CLASSROOM, dataIndex: "classroom" },
    { title: studentListT.TEACHER, dataIndex: "teacherName" },
    {
      title: studentListT.OPERATE,
      dataIndex: "action",
      render: (text: any, record: any) => (
        <Space>
          {hasPermission('ORGANIZATION_CLASS_MANAGEMENT_EDIT') &&
            <ReButton iconName='edit' onClick={clickClassEdit(record)}>
              {`${buttonT.EDIT}${studentListT.CLASS}`}
            </ReButton>
          }

          {hasPermission('ORGANIZATION_CLASS_MANAGEMENT_EDIT') &&
            <ReButton iconName='edit' onClick={(e: any) => {
              clickSubjectEdit(record, e);
            }}
            >
              {`${buttonT.EDIT}${subjectT.SUBJECT}`}
            </ReButton>
          }

          {hasPermission('ORGANIZATION_CLASS_MANAGEMENT_DELETE') &&
            <ReButton iconName='delete' onClick={clickClassDelete(record.classId)} attributeObject={{ type: 'danger' }}>
              {buttonT.DELETE}
            </ReButton>
          }
        </Space>
      ),
    }
  ];

  return (
    <Row>
      <Col span={24}>
        <DraggableTable
          dataSource={classArray}
          columns={columns}
          params={{
            updateSortFunction: updateClassSortFunction,
            hasUpdatePermission: hasPermission('ORGANIZATION_CLASS_MANAGEMENT_EDIT'),
          }}
        />
      </Col>
    </Row>
  );
}

export default Classes;